// Schriften, die in praktisch allen Mailprogrammen verfügbar sind (mit Fallbacks),
// und Schriftgrößen in px. Gemeinsam genutzt von E-Mail-Composer und RichTextEditor (Vorlagen).
export const MAIL_SCHRIFTEN = [
  { label: 'Arial', value: 'Arial, Helvetica, sans-serif' },
  { label: 'Calibri', value: 'Calibri, Carlito, Arial, sans-serif' },
  { label: 'Verdana', value: 'Verdana, Geneva, sans-serif' },
  { label: 'Tahoma', value: 'Tahoma, Geneva, sans-serif' },
  { label: 'Georgia', value: 'Georgia, serif' },
  { label: 'Times New Roman', value: '"Times New Roman", Times, serif' },
  { label: 'Courier New', value: '"Courier New", Courier, monospace' },
];
export const MAIL_SCHRIFTGROESSEN = ['10px', '12px', '13px', '14px', '16px', '18px', '20px', '24px', '28px', '32px'];
